<template>
    <div class="ceramide">
      <i class="iconfont iconfanhui back" @click.stop="back">返回</i>
      <div class="ceramide_title">
        <p>CER-心血管病</p>
        <p>风险评估</p>
        <div class="line"></div>
      </div>
      <div class="checkBtn" @click="checkReport">查看报告</div>
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      status: false,
      fromPath: '',
      username: this.util.getLS(this.api.username)
    }
  },
  methods: {
    // 返回
    back () {
      if (this.fromPath === '/results') {
        this.$router.push('/multiomics')
      } else if (this.fromPath === '/protocol') {
        this.$router.push('/multiomics')
      } else {
        this.$router.back()
      }
    },
    // 获取神经酰胺状态值
    getPointStatus () {
      this.util.get(this.api.point_status, '', (success) => {
        this.status = success.status
      })
    },
    checkReport () {
      if (this.status || this.username === 18800000000) {
        this.$router.push('/protocol')
      } else {
        this.$router.push('/results')
      }
    }
  },
  mounted () {
    let token = this.$route.query.token
    if (token) {
      this.util.setLS(this.api.access_token, token)
    }
    this.getPointStatus()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入fromPath
      vm.fromPath = from.path
    })
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .ceramide {
    width: 100%;
    height: 100%;
    background: url('../../assets/images/ceramide/cerbg.png') no-repeat center;
    background-size: cover;
    position: relative;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .ceramide_title {
      font-size: pxToRem(60px);
      font-weight: bold;
      text-align: right;
      position: absolute;
      top: 24%;
      right: 10%;

      p {
        line-height: pxToRem(82px);
        background:linear-gradient(259deg,rgba(251,214,227,1) 0%, rgba(169,237,233,1) 100%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
      }

      .line {
        width: pxToRem(414px);
        height: pxToRem(4px);
        margin-top: pxToRem(10px);
        background: linear-gradient(259deg,rgba(251,214,227,1),rgba(169,237,233,1));
        box-shadow: 0px 4px 6px 0px rgba(26, 69, 57, 0.35);
      }
    }
    .checkBtn {
      width: pxToRem(200px);
      height: pxToRem(70px);
      line-height: pxToRem(70px);
      background: url('../../assets/images/ceramide/cerbtn1.png') no-repeat center;
      background-size: 100% 100%;
      font-size: pxToRem(29px);
      color: #fff;
      text-align: center;
      letter-spacing: pxToRem(5px);
      position: absolute;
      top: 71%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/index.vue